'use strict';
function throttle(func, delay) {
  var timer = null;
  var startTime = Date.now();

  return function () {
    var curTime = Date.now();
    var remaining = delay - (curTime - startTime);
    var context = this;
    var args = arguments;

    clearTimeout(timer);
    if (remaining <= 0) {
      func.apply(context, args);
      startTime = Date.now();
    } else {
      timer = setTimeout(func, remaining);
    }
  }
}

exports.throttle = throttle;



// WEBPACK FOOTER //
// ./static/util/throttle.js